// extracted by mini-css-extract-plugin
module.exports = {"transaction":"Transaction_transaction__3jXFx"};